import React, { Component } from 'react';

import * as Constants from '../../../constants/constants'
import { Row, Col, Collapse } from 'react-bootstrap'
import i18n from "../../../i18n";

const marginRemove = {
	marginLeft: "0px",
	marginRight: "0px"
}

const marginRemoveWithBC = {
	marginLeft: "0px",
	marginRight: "0px",
	color: "#fff",
	fontWeight: "bold",
	backgroundColor: Constants.MAIN_COLOR3
}

const titleStyle = {
	backgroundColor: Constants.MAIN_COLOR2,
	color: "#fff",
	fontWeight: "bold",
	marginLeft: "0px",
	marginRight: "0px"
}

const padding = {
	padding: "15px",
	wordWrap: "break-word"
}

const paddingConclusion = {
	padding: "15px",
	wordWrap: "break-word",
	color: "#000",
	backgroundColor: Constants.WHITE
}

const leftClass = "col-lg-10 col-sm-9 col-8 border";
const rightClass = "col-lg-2 col-sm-3 col-4 border";
const sIdClass = "col-lg-1 col-sm-1 col-2 d-flex justify-content-center align-self-center"

export default class BasicBuildingBlocks extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	render() {
		return (
			<React.Fragment>
				<Row tabIndex="0" role="button" style={titleStyle} className="border-top" onClick={() => this.setState({ open: !this.state.open })} onKeyUp={this.props.handleKeyUp}>
					<Col style={padding} className="col-lg-12 col-sm-12 col-12">
						<Row style={marginRemove}>
							<Col className="col-lg-11 col-sm-11 col-10">
								<Row>
									<Col style={{ "paddingLeft": "5px" }} className="col-lg-3 col-sm-4 col-5">
										{i18n.t("detailed:" + this.props.data.type)}
									</Col>
									<Col className="col-lg-9 col-sm-8 col-7">
										{this.props.data.id}
									</Col>
								</Row>
							</Col>
							<Col className={sIdClass} style={{ "paddingRight": "0px" }}>
								{this.state.open ?
									<i className="material-icons align-middle" aria-hidden="true">expand_less</i>
									:
									<i className="material-icons align-middle" aria-hidden="true">expand_more</i>
								}
							</Col>
						</Row>
					</Col>
				</Row>
				<Collapse in={this.state.open}>
					<div>
						{this.props.data.fc != null && this.props.data.fc.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:FC")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.fc.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.fc.conclusion.indication)}</Col>
								</Row>
								{this.props.data.fc.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}
							</div>
							: null
						}
						{this.props.data.isc != null && this.props.data.isc.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>

									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:ISC")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.isc.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.isc.conclusion.indication)}</Col>

								</Row>
								{this.props.data.isc.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}
							</div>
							: null
						}
						{this.props.data.vci != null && this.props.data.vci.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>

									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:VCI")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.vci.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.vci.conclusion.indication)}</Col>

								</Row>
								{this.props.data.vci.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}
							</div>
							: null
						}
						{this.props.data.cv != null && this.props.data.cv.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:CV")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.cv.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.cv.conclusion.indication)}</Col>
								</Row>
								{this.props.data.cv.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}
							</div>
							: null
						}
						{this.props.data.sav != null && this.props.data.sav.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:SAV")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.sav.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.sav.conclusion.indication)}</Col>
								</Row>
								{this.props.data.sav.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}
							</div>
							: null
						}
						{this.props.data.xcv != null && this.props.data.xcv.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:XCV")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.xcv.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.xcv.conclusion.indication)}</Col>
								</Row>
								{this.props.data.xcv.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}
								{this.props.data.xcv.subXCV.map((subXCV, i) => {
									return <div key={i}>
										<Row style={marginRemoveWithBC}>
											<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:cert_id")}-{subXCV.id}:</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												color: "#fff",
												backgroundColor: indicationColor(subXCV.conclusion.indication)
											}} className={rightClass}>{i18n.t("detailed:" + subXCV.conclusion.indication)}</Col>
										</Row>
										{subXCV.constraint.length > 0 ?
											<React.Fragment>
												{subXCV.constraint.map((constraint, i) => {
													return <div key={i}>
														<Row style={marginRemove}>
															<Col style={padding,{wordBreak: "brak-all"}}  className={leftClass}>
														
															<Col >
																{i18n.t("detailed:" + constraint.name.value)}</Col>
																{constraint.additionalInfo ? 
															<Col >
																{"(" + constraint.additionalInfo + ")"}
															</Col>:null}
															</Col>

															<Col style={{
																padding: "15px",
																wordWrap: "break-word",
																backgroundColor: constraintColor(constraint.status)
															}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
														</Row>
													</div>
												})}

											</React.Fragment>
											:
											null
										}
										<React.Fragment>
											{subXCV.rfc != null && subXCV.rfc.constraint.length > 0 ?
												<div>
													<Row style={marginRemoveWithBC}>
														<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:RFC")}</Col><Col style={{
															padding: "15px",
															wordWrap: "break-word",
															color: "#fff",
															backgroundColor: indicationColor(subXCV.rfc.conclusion.indication)
														}} className={rightClass}>{i18n.t("detailed:" + subXCV.rfc.conclusion.indication)}</Col>
													</Row>
													{subXCV.rfc.constraint.map((constraint, i) => {
														return <div key={i}>
															<Row style={marginRemove}>
																<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
																	padding: "15px",
																	wordWrap: "break-word",
																	backgroundColor: constraintColor(constraint.status)
																}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
															</Row>
														</div>
													})}
												</div>
												: null
											}
										</React.Fragment>
										<div>
											{i != 0 ?
												<Row style={marginRemoveWithBC}>

													<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:trust_anchor")}</Col>
													{subXCV.trustAnchor != null ?
														<React.Fragment>
															{subXCV.trustAnchor == true ?
																<Col style={{
																	padding: "15px",
																	wordWrap: "break-word",
																	backgroundColor: Constants.GREEN
																}} className={rightClass}>{i18n.t("detailed:PASSED")}</Col>
																:
																<Col style={{
																	padding: "15px",
																	wordWrap: "break-word",
																	backgroundColor: Constants.RED
																}} className={rightClass}>{i18n.t("detailed:NOT_PASSED")}</Col>
															}
														</React.Fragment>
														:
														null
													}

												</Row>
												: null
											}

										</div>

									</div>
								})}

							</div>
							: null
						}
						{this.props.data.psv != null && this.props.data.psv.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:PSV")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.psv.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.psv.conclusion.indication)}</Col>
								</Row>
								{this.props.data.psv.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}

							</div>
							: null
						}
						{this.props.data.pcv != null && this.props.data.pcv.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:PCV")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.pcv.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.pcv.conclusion.indication)}</Col>
								</Row>
								{this.props.data.pcv.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}

							</div>
							: null
						}
						{this.props.data.vts != null && this.props.data.vts.constraint.length > 0 ?
							<div>
								<Row style={marginRemoveWithBC}>
									<Col style={paddingConclusion} className={leftClass}>{i18n.t("detailed:VTS")}</Col><Col style={{
										padding: "15px",
										wordWrap: "break-word",
										color: "#fff",
										backgroundColor: indicationColor(this.props.data.vts.conclusion.indication)
									}} className={rightClass}>{i18n.t("detailed:" + this.props.data.vts.conclusion.indication)}</Col>
								</Row>
								{this.props.data.vts.constraint.map((constraint, i) => {
									return <div key={i}>
										<Row style={marginRemove}>
											<Col style={padding} className={leftClass}>{i18n.t("detailed:" + constraint.name.value)}</Col><Col style={{
												padding: "15px",
												wordWrap: "break-word",
												backgroundColor: constraintColor(constraint.status)
											}} className={rightClass}>{i18n.t("detailed:" + constraint.status)}</Col>
										</Row>
									</div>
								})}

							</div>
							: null
						}
					</div>
				</Collapse >
			</React.Fragment>
		);
	}
}

function indicationColor(tIndication) {
	if (tIndication == "TOTAL_PASSED" || tIndication == "PASSED") {
		return Constants.GREEN;
	} else if (tIndication == "INDETERMINATE") {
		return Constants.ORANGE;
	} else if (tIndication == "TOTAL_FAILED" || tIndication == "FAILED") {
		return Constants.RED;
	}
	return Constants.WHITE;
}

function constraintColor(tConstraint) {
	if (tConstraint == "OK") {
		return Constants.OK;
	} else if (tConstraint == "WARNING" || tConstraint == "IGNORED" || tConstraint == "INFORMATION") {
		return Constants.WARNING;
	} else if (tConstraint == "NOT_OK") {
		return Constants.NOT_OK;
	}
	return Constants.WHITE;
}